var map = {
	"./bali/Rectangle.png": 5636,
	"./bali/Rectangle2.png": 196,
	"./bali/Rectangle3.png": 8869,
	"./bali/Rectangle4.png": 5634,
	"./bali/Rectangle5.png": 6868,
	"./bali/Surakarta.png": 5534,
	"./bali/Surakarta2.png": 2341,
	"./bali/Surakarta3.png": 1711,
	"./bali/Surakarta4.png": 3528,
	"./bali/Surakarta5.png": 6660,
	"./bali/kuta.png": 1353,
	"./bali/nusa_dua.png": 4154,
	"./bali/sama.jpg": 3049,
	"./bali/sanur.png": 5251,
	"./bali/tanah_lot.png": 587,
	"./bali/uluwatu.png": 2929,
	"./bandung/fwalk.png": 1859,
	"./bandung/grafika_bird_park.png": 3090,
	"./bandung/hp_grafika.png": 108,
	"./bandung/maribaya.png": 5408,
	"./bandung/rengganis.png": 5691,
	"./jakarta/kota_tua.png": 8738,
	"./jakarta/monas.png": 6268,
	"./jakarta/ragunan.png": 9102,
	"./jakarta/sea_world.png": 4180,
	"./jakarta/tmii.png": 6667,
	"./jogja/baron.png": 9103,
	"./jogja/keraton_jogja.png": 2727,
	"./jogja/malioboro.png": 4018,
	"./jogja/parangtritis.png": 8720,
	"./jogja/prambanan.png": 814,
	"./jogja/wediombo.png": 4383,
	"./lombok/ampenan.png": 9659,
	"./lombok/malimbu.png": 3227,
	"./lombok/merese.png": 5635,
	"./lombok/senggigi.png": 7893,
	"./lombok/tanjung_aan.png": 4062,
	"./malang/bon_pring.png": 507,
	"./malang/coban_jahe.png": 425,
	"./malang/coban_sewu.png": 3246,
	"./malang/teh_wonosari.png": 7290,
	"./ntt/NTT.png": 597,
	"./ntt/NTT2.png": 2530,
	"./ntt/NTT3.png": 9807,
	"./ntt/lasiana.png": 2498,
	"./ntt/oesapa.png": 7891,
	"./ntt/oetune.png": 6061,
	"./ntt/padar.png": 5874,
	"./ntt/pink.png": 5162,
	"./semarang/danau_rawa_pening.png": 9897,
	"./semarang/hutan_penggaron.png": 3199,
	"./semarang/hutan_pinus_tiamo.png": 3400,
	"./semarang/kampung_kopi_banaran.png": 2473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 521;